import { Component, computed, input } from '@angular/core';

/** 24×24 stroke icons, drawn inline so the strict CSP needs no icon font or sprite. */
const PATHS = {
  stamp: 'M12 7v5l3 2 M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z',
  upload: 'M12 16V4 M7 9l5-5 5 5 M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3',
  file: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z M14 3v5h5',
  proof: 'M9 12l2 2 4-4 M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6Z',
  download: 'M12 4v12 M7 11l5 5 5-5 M5 20h14',
  copy: 'M9 9h10v10H9Z M5 15V5h10',
  check: 'M5 12.5l4.5 4.5L19 7',
  alert: 'M12 8v5 M12 16.5v.5 M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z',
  close: 'M6 6l12 12 M18 6L6 18',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.7 M20 4v4h-4',
  clock: 'M12 7v5l3 2 M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z',
  signout: 'M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3 M10 8l-4 4 4 4 M6 12h10',
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z M20 20l-4-4',
  lock: 'M6 11h12v10H6Z M8 11V7a4 4 0 0 1 8 0v4',
  external: 'M14 4h6v6 M20 4l-9 9 M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
  folder: 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z',
  settings: 'M4 6h9 M17 6h3 M15 4v4 M4 12h3 M11 12h9 M9 10v4 M4 18h11 M19 18h1 M17 16v4',
  list: 'M9 6h11 M9 12h11 M9 18h11 M4.5 6h.01 M4.5 12h.01 M4.5 18h.01',
} as const;

export type IconName = keyof typeof PATHS;

@Component({
  selector: 'app-icon',
  templateUrl: './icon.html',
  host: { style: 'display: inline-flex' },
})
export class Icon {
  readonly name = input.required<IconName>();
  readonly size = input(18);
  protected readonly d = computed(() => PATHS[this.name()]);
}
